import { CheckCircle, Award, Heart, Globe } from "lucide-react";

const features = [
  {
    icon: Award,
    title: "Expert Travel Advisors",
    description: "Our team of seasoned travel experts craft perfect itineraries tailored to your dreams."
  },
  {
    icon: Heart,
    title: "Personalized Service",
    description: "We treat every traveler like family, ensuring your journey is uniquely yours."
  },
  {
    icon: Globe,
    title: "Global Connections",
    description: "Our worldwide partnerships guarantee you the best experiences and exclusive access."
  }
];

const highlights = [
  "24/7 Customer Support",
  "Best Price Guarantee",
  "Flexible Booking Options",
  "Trusted Since 2010"
];

export default function About() {
  return (
    <section id="about" className="py-20 bg-sky-50" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Grid - Bento Style */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div className="rounded-2xl overflow-hidden shadow-lg img-zoom">
                <img
                  src="https://images.pexels.com/photos/7119746/pexels-photo-7119746.jpeg"
                  alt="Happy couple enjoying vacation"
                  className="w-full h-48 object-cover"
                  data-testid="about-image-1"
                />
              </div>
              <div className="rounded-2xl overflow-hidden shadow-lg img-zoom">
                <img
                  src="https://images.pexels.com/photos/297983/pexels-photo-297983.jpeg"
                  alt="Luxury resort view"
                  className="w-full h-64 object-cover"
                  data-testid="about-image-2"
                />
              </div>
            </div>
            <div className="pt-8">
              <div className="rounded-2xl overflow-hidden shadow-lg img-zoom h-full">
                <img
                  src="https://images.pexels.com/photos/547050/pexels-photo-547050.jpeg"
                  alt="Beautiful mountain lake destination"
                  className="w-full h-full object-cover"
                  data-testid="about-image-3"
                />
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="inline-block bg-sky-200 text-sky-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
              About CloudJet
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-sky-900 mb-6">
              Making Travel Dreams Come True Since 2010
            </h2>
            <p className="text-sky-700 mb-6 text-lg">
              At CloudJet, we believe that travel is more than just reaching a destination – 
              it's about creating memories that last a lifetime. Based in Sydney, Australia, 
              we've been helping adventurers explore the world with ease and joy.
            </p>
            <p className="text-sky-700 mb-8">
              Our passionate team combines local expertise with global connections to deliver 
              extraordinary travel experiences. Whether you're seeking a tropical escape, 
              cultural immersion, or adventure expedition, we're here to make it happen.
            </p>

            {/* Highlights */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {highlights.map((item, index) => (
                <div key={index} className="flex items-center gap-2">
                  <CheckCircle className="text-sky-600 flex-shrink-0" size={20} />
                  <span className="text-sky-800 font-medium">{item}</span>
                </div>
              ))}
            </div>

            {/* Features */}
            <div className="space-y-4">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-4 p-4 bg-white rounded-xl border border-sky-100 hover-lift">
                  <div className="w-12 h-12 bg-sky-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <feature.icon className="text-sky-600" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-sky-900 mb-1">{feature.title}</h3>
                    <p className="text-sky-600 text-sm">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
